import { type PermissionDefinition } from '../../../store/role/role'

const READ_ACTIONS = new Set(['read', 'list', 'download', 'download_attachment', 'sample'])

export const getAccessType = (scopeId: string): 'read' | 'write' | 'admin' => {
  const action = scopeId.split(':')[1] ?? ''
  if (action === 'admin' || action.startsWith('admin_')) {
    return 'admin'
  }
  if (READ_ACTIONS.has(action)) {
    return 'read'
  }
  return 'write'
}

const RESOURCE_TO_CATEGORY: Record<string, string> = {
  ext_user: 'Contacts',
  room_session: 'Meetings',
  room: 'Meetings',
  room_event: 'Meetings',
  room_record: 'Meetings',
  airesult: 'AI Results',
  aifeature: 'AI Results',
  ai_agent: 'AI Agents',
  ai_agent_result: 'AI Agents',
  integration: 'Integrations',
  task: 'Tasks',
  meeting_template: 'Meeting Templates',
  meeting_note: 'Meeting Notes',
  scorecard: 'Scorecards',
  scorecardresult: 'Scorecards',
  webhook: 'Webhooks',
}

export const getCategory = (scopeId: string): string => {
  const resource = scopeId.split(':')[0]
  return RESOURCE_TO_CATEGORY[resource] ?? 'Other'
}

export interface ScopeItem {
  scope: string
  label: string
  category: string
  accessType: 'read' | 'write' | 'admin'
}

export const buildScopeGroups = (scopes: string[], permissions: PermissionDefinition[] = []): Map<string, ScopeItem[]> => {
  const permissionMap = new Map(permissions.map((p) => [p.id, p]))
  const items = scopes.map((scopeId) => ({
    scope: scopeId,
    label: permissionMap.get(scopeId)?.description ?? scopeId,
    category: getCategory(scopeId),
    accessType: getAccessType(scopeId),
  }))

  return items.reduce((grouped, item) => {
    const list = grouped.get(item.category) ?? []
    grouped.set(item.category, [...list, item])
    return grouped
  }, new Map<string, ScopeItem[]>())
}
